import { render, staticRenderFns } from "./ModalDuplicates.vue?vue&type=template&id=6379988a"
import script from "./ModalDuplicates.vue?vue&type=script&lang=js"
export * from "./ModalDuplicates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports